// extracted by mini-css-extract-plugin
export default {"taskHeader":"TaskNewForm_taskHeader__8Wc8j","taskTitle":"TaskNewForm_taskTitle__EQ1eo","file":"TaskNewForm_file__Pjcw-","dropBox":"TaskNewForm_dropBox__T9sHz"};